import { Text as ReactNativeText } from 'react-native';
import styled from 'styled-components/native';
import { color as themeColor } from '../../theme';
import { fonts, font_variant_styles } from '../../theme/typography';
import { presets } from './Text.presets';
import { TextProps } from './Text.props';

const Text = styled(ReactNativeText)<TextProps>`
  ${font_variant_styles.p.regular}
  color: ${themeColor.text};
  overflow: visible;
  ${({ preset, weight, variant }) => {
    if (preset) {
      return presets[preset];
    }

    return font_variant_styles[variant || 'p'][weight || 'regular'];
  }}
  ${({ bold }) => (bold ? 'font-weight: bold;' : '')}
  ${({ italic }) => (italic ? 'font-style: italic;' : '')}
  ${({ kalam }) => (kalam ? `font-family: ${fonts.kalam};` : '')}
`;

export { Text };
